import { useTranslation } from "react-i18next";
import { HiOutlineArrowLongRight, HiOutlineTrash } from "react-icons/hi2";

import Button from "@/components/atoms/Button";
import Input from "@/components/atoms/input/Input";

const MatchUnmatchedRowItemsSkeleton = ({ count = 3 }: { count: number }) => {
  return [...Array(count)].map((_, index) => <MatchUnmatchedRowItemSkeleton key={index} />);
};

export default MatchUnmatchedRowItemsSkeleton;

const MatchUnmatchedRowItemSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 items-center gap-x-16 border-secondary px-4 py-3 text-sm font-medium [&:not(:first-child)]:border-t">
      <div className="flex justify-between self-start p-2">
        <div className={"grid animate-pulse gap-y-1 space-y-0.5"}>
          <div className={"h-3 w-32 rounded-full bg-gray-200"} />
          <div className={"h-3 w-20 rounded-full bg-gray-200"} />
          <div className={"h-3 w-36 rounded-full bg-gray-200"} />
        </div>
        <HiOutlineArrowLongRight className="mt-1 size-5" />
      </div>

      <div>
        <div className={"flex gap-3"}>
          <div className={"flex-1"}>
            <Input disabled placeholder={t("unmatched.placeholder")} />
          </div>
          <Button
            label={t("unmatched.discard")}
            color={"error"}
            disabled
            variants={"text"}
            size={"xs"}
            leadingIcon={<HiOutlineTrash className={"size-5"} />}
          />
        </div>
        <div className={"mt-3 grid gap-3"}>
          <h4 className={"text-xs font-medium text-tertiary"}>{t("unmatched.suggested")} </h4>
          <div className={"flex gap-1.5"}>
            <div className={"h-4 w-20 animate-pulse rounded-full bg-gray-200"} />
            <div className={"h-4 w-20 animate-pulse rounded-full bg-gray-200"} />
            <div className={"h-4 w-20 animate-pulse rounded-full bg-gray-200"} />
          </div>
        </div>
      </div>
    </div>
  );
};
